var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"campaign-info"},[_c('AppText',[_vm._v(_vm._s(_vm.$t('campaigns.general.lastUpdated')))]),_c('AppText',{attrs:{"type":"date"}},[_vm._v(_vm._s(_vm.date))]),_c('AppText',{attrs:{"type":"year"}},[_vm._v(_vm._s(_vm.year))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }